export class ChecklistAction {
    id: number;
    checklist_completed_id: number;
    question_id: number;
    user: string;
    deadline: Date;
    action: string;
    updated_at: Date;
}
